import { api } from "@/lib/api";

const CHUNK = 4 * 1024 * 1024;
export const VIDEO_MAX = 150 * 1024 * 1024;
export const VIDEO_MAX_SECONDS = 180;

export function videoDuration(file) {
  return new Promise((resolve) => {
    const v = document.createElement("video");
    v.preload = "metadata";
    v.onloadedmetadata = () => { URL.revokeObjectURL(v.src); resolve(v.duration); };
    v.onerror = () => resolve(null);
    v.src = URL.createObjectURL(file);
  });
}

export async function uploadVideoChunked(file, onProgress) {
  const uploadId = crypto.randomUUID();
  const total = Math.ceil(file.size / CHUNK);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", String(i));
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), "chunk.bin");
    await api.post("/posts/video/chunk", fd);
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  const { data } = await api.post("/posts/video/complete", { upload_id: uploadId, filename: file.name, total_chunks: total });
  return data.video_path;
}
